/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'tissue': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M738 610v-61a8 8 0 00-8-8H294a8 8 0 00-8 8v61h96c17.673 0 32 14.327 32 32v286c0 17.673-14.327 32-32 32H96c-17.673 0-32-14.327-32-32V642c0-17.673 14.327-32 32-32h126V509c0-17.673 14.327-32 32-32h226v-63H369c-17.673 0-32-14.327-32-32V96c0-17.673 14.327-32 32-32h286c17.673 0 32 14.327 32 32v286c0 17.673-14.327 32-32 32H544v63h226c17.673 0 32 14.327 32 32v101h126c17.673 0 32 14.327 32 32v286c0 17.673-14.327 32-32 32H642c-17.673 0-32-14.327-32-32V642c0-17.673 14.327-32 32-32h96zM409 128a8 8 0 00-8 8v206a8 8 0 008 8h206a8 8 0 008-8V136a8 8 0 00-8-8H409zM136 674a8 8 0 00-8 8v206a8 8 0 008 8h206a8 8 0 008-8V682a8 8 0 00-8-8H136zm546 0a8 8 0 00-8 8v206a8 8 0 008 8h206a8 8 0 008-8V682a8 8 0 00-8-8H682z"/>'
  }
})
